import spreadsheet from './src/spreadsheet.vue'
import cell from './src/cell.vue'
import detail from './src/detail.vue'
import fileUpload from './src/file-upload.vue'

export { spreadsheet, cell, detail, fileUpload }
